import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "@/components/common/BackButton";
import { useToast } from "@/components/ui/use-toast";
import {
  CustomPageForm,
  type CustomPageFormValues,
} from "./components/CustomPageForm";
import { useCreateCustomPage } from "./hooks/useCustomPages";

export const CreateCustomPagePage: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const createCustomPage = useCreateCustomPage();

  const handleSubmit = async (data: CustomPageFormValues) => {
    await createCustomPage.mutateAsync(data);
    toast({
      title: "Success",
      description: "Custom page created successfully",
    });
    navigate("/custom-pages");
  };

  return (
    <div className="flex w-full flex-col space-y-8 p-12">
      <BackButton className="self-start" />

      <div className="space-y-2">
        <h1 className="text-3xl font-semibold text-zinc-900">
          Create Custom Page
        </h1>
        <p className="text-zinc-500">
          Add a new HTML page that can be opened from the guest app.
        </p>
      </div>

      <CustomPageForm
        submitLabel="Create page"
        isSubmitting={createCustomPage.isPending}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
